controllers.controller('WithdrawalComplianceController', [
    '$scope', '$state', '$timeout', '$location', '$ionicScrollDelegate', 'ionicToast', '$ionicLoading',
    'LocaleService', 'API', 'ErrorService', 'AccountService', 'Storage', 'Utils', 'UserService', 'constants',
    function ($scope, $state, $timeout, $location, $ionicScrollDelegate, ionicToast, $ionicLoading,
              LocaleService, API, ErrorService, AccountService, Storage, Utils, UserService, Const) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.translation = LocaleService.translation;

        $scope.permit = {
            checked: false
        };
        $scope.modal = { actionText: LocaleService.translation.try_again, state: false };

        $scope.questions = [];

        $scope.formData = {};
        $scope.formTemplate = [];
        $scope.quizItems = [];

        $scope.navigate = function (state, params) {
            log('navigate to ', state);
            return $state.go(state, params);
        };


        API.questions()
            .then(checkResponse)
            .then(function (response) {
                var customerAnswers = Array.isArray(response.customerAnswers) ? response.customerAnswers : [];

                return response.questions.reduce(function (accum, rawQuestion) {

                    var customerAnswer = customerAnswers.length && customerAnswers.find(function(customerAnswer) {
                        return customerAnswer.questionId === rawQuestion.id;
                    }) || {};

                    accum.push({
                        id: rawQuestion.id,
                        label: ($scope.translation && $scope.translation.quizQuestions[rawQuestion.id.toString()])
                            || rawQuestion.id.toString(),

                        allowOther: !!rawQuestion.free,
                        isMulti: !!rawQuestion.multi,
                        other: customerAnswer.other || undefined,
                        otherShown: !!customerAnswer.other,
                        formModelName: 'question' + rawQuestion.id,

                        answers: rawQuestion.answers.reduce(function(accum, rawAnswer) {
                            accum[rawAnswer.toString()] =  {
                                label: ($scope.translation && $scope.translation.quizAnswers[rawAnswer.toString()])
                                    || rawAnswer.toString(),
                                slaveTo: ((customerAnswer.answerIds || []).indexOf(rawAnswer) !== -1),
                                isOn: true
                            };
                            return accum;
                        }, {})
                    });

                    return accum;
                }, []);
            })
            .then(function (quizItems) {
                $scope.quizItems = quizItems;
                $scope.formTemplate.push(
                    {
                        "type": "titleseparator",
                        "label": $scope.translation.withdrawalInformation,
                        "labelclass": "separator-title",
                        "mainclass": "title"
                    }
                );

                quizItems.map(function (quizItem) {

                    if (Object.keys(quizItem.answers).length) {
                        !$scope.formData[quizItem.formModelName] && ($scope.formData[quizItem.formModelName] = {});

                        Object.keys(quizItem.answers).forEach(function(answerKey){
                            !!quizItem.answers[answerKey].slaveTo && ($scope.formData[quizItem.formModelName][answerKey] = true);
                        });
                    }

                    if (quizItem.isMulti) {
                        $scope.formTemplate.push(
                            {
                                "type": "checklist",
                                "label": quizItem.label,
                                "labelclass": "question-title text-center",
                                "labelid": quizItem.formModelName,
                                "class": "'form-select no-appearance checklist'",
                                "model": quizItem.formModelName,
                                "mainwrapper": "div",
                                "mainclass": "tap-checklist",
                                "empty": "Select option",
                                "val": $scope.formData[quizItem.formModelName] || null,
                                "required": true,
                                "options": quizItem.answers,
                                "multiple": quizItem.isMulti
                            }
                        );
                    }
                    else {
                        $scope.formTemplate.push(
                            {
                                "type": "select",
                                "label": quizItem.label,
                                "labelclass": "question-title text-center",
                                "labelid": quizItem.formModelName,
                                "class": "'form-select no-appearance select'",
                                "model": quizItem.formModelName,
                                "mainwrapper": "div",
                                "mainclass": "tap-select",
                                "empty": "Select option",
                                "val": Object.keys($scope.formData[quizItem.formModelName]).length && $scope.formData[quizItem.formModelName] || null,
                                "required": true,
                                "options": quizItem.answers
                            }
                        );
                    }

                    $scope.formTemplate.push(
                        {
                            "type": "validatemessages",
                            "mainclass": "font-12 messages",
                            "formMessages": quizItem.formModelName,
                            "errorMessageClass": "help-block",
                            "errorMessages": [
                                {
                                    "field": "required",
                                    "text": "Please select one option"
                                }
                            ]
                        }
                    );

                    if (quizItem.allowOther) {
                        $scope.formData[quizItem.formModelName + 'OtherAllow'] = !!quizItem.other;

                        $scope.formTemplate.push(
                            {
                                "type": "checkbox",
                                "label": "Other",
                                "labelclass": "form-group item-input item-stacked-label p-0",
                                "mainclass": "font-12 messages checkbox-wrapper",
                                "class": "'checkbox-other'",
                                // "class": "'checkbox-other'",
                                "formMessages": quizItem.formModelName,
                                "model": quizItem.formModelName + 'OtherAllow',
                                "slaveTo" : !!quizItem.other
                            }
                        );

                        $scope.formTemplate.push(
                            {
                                "type": "text",
                                "class": "{'form-select no-appearance': true, 'shown': formData." + quizItem.formModelName + "OtherAllow}",
                                "model": quizItem.formModelName + 'OtherAnswer',
                                "mainwrapper": "div",
                                "mainclass": "",
                                "placeholder": $scope.translation.specifyOtherAnswer,
                                "val": quizItem.other,
                                "minLength": 3,
                                "required": true
                            }
                        );
                    }
                });
            })
        ;


        $scope.validateForm = function() {
            var answerFound = false;

            return !(Object.keys($scope.formData).length && $scope.quizItems.find(function(quizItem){
                // clear other answer when toggled off
                if (!$scope.formData[quizItem.formModelName + 'OtherAllow'] &&
                    $scope.formData[quizItem.formModelName + 'OtherAnswer'] &&
                    $scope.formData[quizItem.formModelName + 'OtherAnswer'].length
                ) {
                    $scope.formData[quizItem.formModelName + 'OtherAnswer'] = undefined;
                }

                answerFound = Object.keys($scope.formData[quizItem.formModelName] || {}).find(function (answerKey) {
                    return $scope.formData[quizItem.formModelName][answerKey];
                });

                return !(
                    !$scope.formData[quizItem.formModelName + 'OtherAllow'] && answerFound
                    ||
                    (
                        $scope.formData[quizItem.formModelName + 'OtherAllow'] &&
                        $scope.formData[quizItem.formModelName + 'OtherAnswer'] &&
                        $scope.formData[quizItem.formModelName + 'OtherAnswer'].length > 2
                    )
                );
            }));
        };

        function formatAnswers () {
            function collectAnswers(question) {
                if (typeof question === 'string') {
                    return [Number(question)];
                }
                return Object.keys(question).reduce(function(accum, answerKey){
                    if (answerKey !== '$$hashKey' && question[answerKey]) {
                        accum.push(Number(answerKey))
                    }
                    return accum;
                }, []);
            }

            return $scope.quizItems.reduce(function(accum, quizItem) {
                accum.push({
                    questionId: quizItem.id,
                    answerIds: collectAnswers($scope.formData[quizItem.formModelName]),
                    answer: $scope.formData[quizItem.formModelName + 'OtherAnswer'] || ''
                });
                return accum;
            }, [])
        }

        $scope.processForm = function () {
            $ionicLoading.show();

            return API.questionnaire({
                    answers: formatAnswers($scope.formData)
                })
                .then(checkResponse)
                .then(function () {
                    $ionicLoading.hide();
                    return $state.go('root.app.uploadDocuments');
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";
                    $scope.modal.state = true;
                })

        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'DynamicController',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'updateCustomerFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }


        $scope.$on('$destroy', function () {
            $scope.formData = {};
            $scope.formTemplate = [];
            $scope.quizItems = [];
        });
    }
]);
